<template>
  <div>
    <div class="mb-2">{{ title }}</div>
    <b-progress max="100" show-progress animated :value="progression" :variant="variant"> </b-progress>
    <div class="mt-1">
      {{ description }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'progress-bar',

  props: {
    progression: {
      type: [Number, String],
      required: true,
    },
    late: {
      type: Number,
      default: 0,
    },

    description: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: '',
    },
  },

  computed: {},
}
</script>

<style scoped></style>
